export const CHECKBOX_CHOICE = 'yes';

export const QUESTION_TYPE_OPTIONS = [
  { value: 'open_text', label: 'Open text' },
  { value: 'checkbox', label: 'Checkbox' },
  { value: 'multiple_choice', label: 'Multiple choice' },
  { value: 'number', label: 'Number only' },
  { value: 'date', label: 'Date' },
  { value: 'yes_no', label: 'Yes / No' },
  { value: 'true_false', label: 'True / False' },
  { value: 'image_upload', label: 'Image upload' },
];

export const QUESTION_TYPES = {
  open_text: 'open_text',
  checkbox: 'checkbox',
  multiple_choice: 'multiple_choice',
  number: 'number',
  date: 'date',
  yes_no: 'yes_no',
  true_false: 'true_false',
  image_upload: 'image_upload',
};

export const QUESTIONNAIRE_IMAGE_MAX_BYTES = 5 * 1024 * 1024;
export const QUESTIONNAIRE_IMAGE_HINT = 'PNG, JPG · up to 5 MB';
export const QUESTIONNAIRE_IMAGE_ACCEPT = 'image/jpeg,image/jpg,image/png';
export const QUESTIONNAIRE_IMAGE_CSV_PLACEHOLDER = 'Image (view in dashboard)';

export const buildMultipleChoiceOptions = (choicesInput, allowMultiple) => {
  const choices =
    typeof choicesInput === 'string'
      ? choicesInput
          .split(',')
          .map(s => s.trim())
          .filter(Boolean)
      : choicesInput;
  return {
    choices: Array.isArray(choices) ? choices : [choices],
    allowMultiple: !!allowMultiple,
  };
};

export const isCheckboxQuestion = question => {
  if (!question || question.type !== QUESTION_TYPES.multiple_choice) {
    return false;
  }
  const choices = question.options?.choices;
  if (!Array.isArray(choices) || choices.length !== 1) {
    return false;
  }
  if (String(choices[0]).toLowerCase() !== CHECKBOX_CHOICE) {
    return false;
  }
  return !question.options?.allowMultiple;
};

export const resolveQuestionDisplayType = question => {
  if (isCheckboxQuestion(question)) {
    return QUESTION_TYPES.checkbox;
  }
  return question?.type || QUESTION_TYPES.open_text;
};

export const getQuestionTypeLabel = type =>
  QUESTION_TYPE_OPTIONS.find(t => t.value === type)?.label || type;

export const getQuestionDisplayTypeLabel = question =>
  getQuestionTypeLabel(resolveQuestionDisplayType(question));

export const getQuestionFormValues = question => {
  const displayType = resolveQuestionDisplayType(question);
  const values = {
    type: displayType,
    allowMultiple: false,
  };
  if (displayType === QUESTION_TYPES.multiple_choice && question?.options?.choices) {
    values.choices = Array.isArray(question.options.choices)
      ? question.options.choices.join(', ')
      : question.options.choices;
    values.allowMultiple = !!question.options?.allowMultiple;
  }
  return values;
};

export const buildQuestionApiPayload = ({
  text,
  type,
  choices,
  allowMultiple,
  options,
  ...rest
}) => {
  if (type === QUESTION_TYPES.checkbox) {
    return {
      text,
      type: QUESTION_TYPES.multiple_choice,
      options: { choices: [CHECKBOX_CHOICE], allowMultiple: false },
      ...rest,
    };
  }

  const payload = { text, type, ...rest };
  if (type === QUESTION_TYPES.multiple_choice) {
    if (options?.choices?.length) {
      payload.options = options;
    } else if (choices !== undefined && choices !== null && choices !== '') {
      payload.options = buildMultipleChoiceOptions(choices, allowMultiple);
    }
  }
  return payload;
};

export const buildQuestionDraftFromForm = (values, text) => {
  const draft = {
    text,
    type: values.type,
  };
  if (values.type === QUESTION_TYPES.multiple_choice && values.choices) {
    draft.options = buildMultipleChoiceOptions(values.choices, values.allowMultiple);
  }
  return draft;
};

export const SURVEY_QUESTION_TYPE_OPTIONS = QUESTION_TYPE_OPTIONS.filter(
  option => option.value !== QUESTION_TYPES.image_upload
);

export const isSurveySupportedQuestionType = type => type !== QUESTION_TYPES.image_upload;
